import { Record } from 'immutable';
export const TranslatedLogEventMessageKeys = {
  FIELD_KEY: 'fieldKey',
  MESSAGE: 'message',
  IS_PRIMARY_RISK_MESSAGE: 'isPrimaryRiskMessage',
  IS_SECONDARY_RISK_MESSAGE: 'isSecondaryRiskMessage'
};
const defaultProps = {
  [TranslatedLogEventMessageKeys.FIELD_KEY]: undefined,
  [TranslatedLogEventMessageKeys.MESSAGE]: undefined,
  [TranslatedLogEventMessageKeys.IS_PRIMARY_RISK_MESSAGE]: undefined,
  [TranslatedLogEventMessageKeys.IS_SECONDARY_RISK_MESSAGE]: undefined
};
export default class TranslatedLogEventMessage extends Record(defaultProps, 'TranslatedLogEventMessage') {
  getMessage() {
    return this[TranslatedLogEventMessageKeys.MESSAGE];
  }
}